import { Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import logoEP from 'assets/img/landing/logoEP.png'

const NavItem = ({ label, url, isLast }: { label: string; url: string; isLast?: boolean }) => {
  return (
    <Nav.Item as="li" className={classNames({ 'border-bottom border-translucent border-bottom-lg-0': !isLast })}>
      <Nav.Link href={url} className="lh-1 py-0 fs-7 fw-bold py-3">
        {label}
      </Nav.Link>
    </Nav.Item>
  );
};

const DefaultLandingNavbar = ({ className }: { className?: string }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const toggleShadowClass = () => {
      if (window.scrollY > 300) {
        containerRef.current?.classList.add('navbar-shadow');
      } else {
        containerRef.current?.classList.remove('navbar-shadow');
      }
    };
    document.addEventListener('scroll', toggleShadowClass);
    return () => document.removeEventListener('scroll', toggleShadowClass);
  }, []);

  return (
    <div className={classNames(className, 'bg-body-emphasis sticky-top landing-navbar')} ref={containerRef}>
      <Navbar className="px-3 px-lg-7 px-xxl-3 container-small" expand="lg">
        <Navbar.Brand as={Link} to="/" className="text-decoration-none flex-1 flex-lg-grow-0">
          {/* Aquí puedes renderizar tu logo images/logoEP.png */}
          <img src={logoEP} alt="logo estudio parkes" height="80" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto mb-2 mb-lg-0" as="ul">
            <NavItem label="Derecho Laboral" url="#derecholaboral" />
            <NavItem label="Sucesiones" url="#sucesiones" />
            <NavItem label="Accidentes Civiles" url="#derechocivil" />
            <NavItem label="Ubicación" url="#ubicacion" />
            <NavItem label="Contacto" url="#contacto" />
          </Nav>

          <div className="d-grid d-lg-flex gap-4 align-items-center">
            <a href="/app" className="btn btn-link p-0 text-body order-1 order-lg-0 text-decoration-none fw-bold">
              Ingreso Staff <i className="bi bi-box-arrow-in-right ms-1"></i>
            </a>
            <a 
              href="https://api.whatsapp.com/send/?phone=5491153069479&text&type=phone_number&app_absent=0" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-success rounded-pill px-3"
              style={{ backgroundColor: '#25D366', borderColor: '#25D366' }}
            >
              WhatsApp <i className="bi bi-whatsapp ms-1"></i>
            </a>
          </div>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};

export default DefaultLandingNavbar;